// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI, { Loading } from 'element-ui'
import App from './App'
import router from './router'
import store from './store'
import './permission' // 权限控制
import 'element-ui/lib/theme-chalk/base.css'
import 'element-ui/lib/theme-chalk/index.css'
import './icons' // icon
import * as filters from './filters' // global filters
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'
// 动态修改meta搜索引擎
import Meta from 'vue-meta'

// 自定义 breadcrumbItem
import BreadcrumbItem from '@/components/breadcrumbItem/index.vue'
import '@/commons/mathjax/mathjax-config.js'
import '@/commons/mathjax/es5/tex-mml-svg.js'
Vue.use(Meta)
Vue.config.productionTip = false

Vue.use(ElementUI)
Vue.component(CollapseTransition.name, CollapseTransition)
Vue.component('breadcrumb-item', BreadcrumbItem)

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})
Vue.directive('blur', {
  inserted: el => {
    var ele = el
    if (el.tagName === 'DIV') {
      ele = el.querySelector('input') || el.querySelector('select')
    }
    ele.onblur = function (e) {
      e.preventDefault()
      setTimeout(function() {
        window.scrollTo(0, 0)
      }, 100)
    }
  }
})

// 使用钩子函数对路由进行跳转
router.beforeEach((to, from, next) => {
  // if(to.name=='start'){
  //   store.dispatch('enterFullScreen',true)
  // }
  if (from.name == 'examRecord' && to.name == 'start') { // 回退操作
    next('/exams')
  } else {
    next()
  }
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js